import { Button, Typography } from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton'

type ISecondStepProps = {
  onAgree: () => void;
  onCancel: () => void;
  loginProcessing: boolean;
}

const SecondStep = ({ onAgree, onCancel, loginProcessing }: ISecondStepProps) => (
  <div className="step-second flex flex-col justify-center w-full">
    <Typography>Please click to “I Agree” to confirm you read</Typography>
    <Typography>
      <a target="_blank" className="font-medium" href="http://ridemyle.com/terms-and-conditions" rel="noreferrer">Terms & Conditions</a>
      <a target="_blank" className="font-medium" href="http://ridemyle.com/privacy-policy" rel="noreferrer"> & Privacy Policy</a>
    </Typography>

    <div className="btn-container">
      <LoadingButton
        loading={loginProcessing}
        variant="contained"
        onClick={onAgree}>
        I AGREE
      </LoadingButton>
      <Button
        variant="contained"
        onClick={onCancel}>
        CANCEL
      </Button>
    </div>
  </div>
)

export default SecondStep
